import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'get_started',
} as const satisfies Location
